import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { AppConfig, validateAppConfig } from './app-config';
import { CoreStore } from '../state/core.store';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private readonly _http = inject(HttpClient);
  private readonly _store = inject(CoreStore);

  load(): Observable<void> {
    return this._http.get<AppConfig>(`/assets/config/config.json?t=${Date.now()}`).pipe(
      map((raw) => {
        this._store.setConfig(validateAppConfig(raw));
      }),
      catchError((err) => {
        console.error('[Config] Impossibile caricare config.json — l\'applicazione non può avviarsi.', err);
        return throwError(() => err);
      }),
    );
  }
}